
<!-- It's main container of ct-navbar -->
<div class="ly-main-container ly-flex bs-navbar th-bg-main ">
  <!-- It's sub container of ct-navbar -->
  <div class="ly-container bs-sub-container ly-flex"> 
       <!-- It's container division inside of the ct-navbar -->
      <div class="ly-flex-inside">
          <!-- It's the click event container of the icon -->
          <div id="menu" class="ly-space-container bs-container-icon" (click)="onMenuNavClick()">
              <div class="bs-svg ly-flex-inside" >
                   <!-- It's the menu svg icon  -->
                  <object id="menu-icon-svg"
                      data="assets/icons/menu.svg"
                      type="image/svg+xml"
                      title="Menu">
                  </object>
              </div>
          </div>
      </div>
      <!-- It's container division inside of the ct-navbar -->
      <div class="ly-flex-inside">
        <div id="organization" class="ly-space-container" *ngIf="userHasOrganization()">
          <div class="bs-container-icon user-select-none" (click)="openOrganizationView()">
            <div class="bs-svg ly-flex-inside">
              <object id="organization-icon-svg"
                      data="assets/icons/organization-nav-icon.svg"
                      type="image/svg+xml"
                      title="Organization">
              </object>
            </div>
          </div>
        </div>

        <div id="help" class="ly-space-container position-relative">
          <!-- It's the click event container of the icon -->
          <div class="bs-container-icon user-select-none" (click)="clickHelp()">
            <div class="bs-svg ly-flex-inside">
              <!-- It's the help svg icon  -->
              <object id="help-icon-svg"
                      data="assets/icons/help.svg"
                      type="image/svg+xml"
                      title="Help"
                      *ngIf="!isHelpWindowVisible">
              </object>
              <object id="help-icon-svg"
                      data="assets/icons/Focus.svg"
                      type="image/svg+xml"
                      title="Help"
                      *ngIf="isHelpWindowVisible">
              </object>
            </div>
          </div>

          <div class="help-window p-3" [ngClass]="{
            'd-none': !isHelpWindowVisible,
            'd-block': isHelpWindowVisible
          }">
            <h3 class="bs-h3 th-text-main">Centro de ayuda</h3>
            <!--  <div class="d-flex align-items-center"> -->
            <div class="d-flex align-items-center mt-3 mb-3">

              <object id="help-svg"
                      data="assets/icons/info.svg"
                      type="image/svg+xml"
                      title="Report">
              </object>
              <span class="bs-p ms-2 bs-placeholder" (click)="openHelpCenter()">Reportar problema</span>
            </div>

            <div class="divider w-100 th-bg-border-line-background"></div>

            <div class="d-flex align-items-center mt-3 mb-1">
              <object id="help-icon-svg"
                      data="assets/icons/Star 2.svg"
                      type="image/svg+xml"
                      title="Help">
              </object>
              <span class="bs-p ms-2 bs-placeholder">Recorrido guiado</span>
              <button class="ms-3 th-bg-main th-text-white bs-button"
                      (click)="startGuidedTour()">
                <span>Iniciar</span>
              </button>
            </div>
          </div>
    </div>
  <!-- <div id="notification" class="ly-space-container">CreateTicketAsync
    <!-- It's the click event container of the icon
    <div class="bs-container-icon" (click)="clickNotification()">
      <div class="bs-svg ly-flex-inside">
        <!-- It's the notification svg icon
        <object id="notification-icon-svg"
                data="assets/icons/notification.svg"
                type="image/svg+xml"
                title="Notification">
        </object>
      </div>
    </div>
  </div> -->
              <div id="log-out" class="ly-space-container">
                <!-- It's the click event container of the icon -->
                <div class="bs-container-icon" (click)="logOut()">
                  <div class="bs-svg ly-flex-inside">
                    <!-- It's the log-out svg icon  -->
                    <object id="log-out-icon-svg"
                            data="assets/icons/log-out.svg"
                            type="image/svg+xml"
                            title="Log out">
                    </object>
                  </div>
                </div>
              </div>
            </div>
  </div>
</div>

